'use client';
import {ReactNode} from "react";
import {ThemeContext} from "@web-libs/features/branding/theme/application/use-theme.concern";
import {Theme} from "@web-libs/features/branding/theme/domain/theme.types";

export const ThemeProvider = ({children, theme}: { children: ReactNode, theme:Theme }) => {
    return (
        <ThemeContext.Provider value={theme}>
            {children}
        </ThemeContext.Provider>
    )
}
